import { request } from './Api';

export async function getAdminDashboard() {
    const response = await request('/api/admin/dashboard');
    return response.data || {};
}
